const CATEGORIES: {
  label: string;
  slug: string;
  description: string;
}[] = [
  {
    label: 'All',
    slug: 'latest',
    description: '',
  },
  {
    label: 'Engineering leadership',
    slug: 'engineering-leadership',
    description:
      'Scale your team quickly and effectively, and build a culture that helps your engineers thrive.',
  },
  {
    label: 'Remote HR',
    slug: 'remote-hr',
    description: 'Empower your team to do their best work. Learn about Remote HR best practices.',
  },
  {
    label: 'Talent markets',
    slug: 'talent-markets',
    description:
      'Unbelievable engineering talent is all over the world. Find out which markets are leading the tech talent race.',
  },
  {
    label: 'Hiring + recruiting',
    slug: 'hiring-recruiting',
    description:
      'Tackle the challenge of finding the right person for your team. Streamline your recruitment process – from compensation to branding.',
  },
  {
    label: 'Remote how-to’s',
    slug: 'remote-how-tos',
    description: 'Nurture collaboration, communication, and trust in your remote team. Learn how.',
  },
];

export default CATEGORIES;
